export default __webpack_public_path__ + "static/rotate-phone-white-2555ea412483713e10d6746999916061.png";